<template>
		<div class="course-list">
			<div v-if="showIframe">
				<div class="back" @click="goBack">返回</div>
			  <iframe allow="camera; microphone; geolocation; fullscreen; clipboard-read; clipboard-write; accelerometer; gyroscope; payment; display-capture; autoplay" :src="iframeSrc" style="width: 100%; height: calc(100vh - 4rem); border: none;"></iframe>
			</div>
			<div v-if="!showIframe" class="sub-head">
				<div class="course-title">考试列表</div>
				<div class="subject">
					<div class="tab" v-for="(item,index) in tabList" :key="index" :class="actTab==item.id?'actTab':''" @click="getSubject(item.id)">{{item.name}}</div>
				</div>
			</div>	
			<div v-if="!showIframe" class="course-cont">
				<div class="course-card" v-for="(item,index) in examList":key="index">
					<div class="course-bg"></div>
					<div class="course-name">{{item.title}}</div>
					<div class="course-text">{{item.text}}</div>
					<div class="course-btn">
						<div v-if="item.end_time" @click="goQftx(item,1)"  class="btn">重新考试</div>
						<div v-if="item.end_time" @click="goQftx(item)"  class="btn">查看试卷</div>
						<div v-if="!item.end_time" @click="goQftx(item)"  class="btn btn-ok">开始考试</div>
					</div>
				</div>
			</div>
		</div>
</template>
<script>

export default {
	name: 'index',

	components: {},

	data(){
		return {
			actTab:localStorage.getItem('actTab')||1,
			showIframe: false,
			exam:{},
			iframeSrc: '',
			examList:"",
			// examList:[
			// 	{
			// 		id:1,
			// 		name:'湖南2024中考模拟考试--数学',
			// 		bg:require('../assets/banner-2.png'),
			// 		text:'湖南2024中考模拟考试--数学',
			// 		subject:1,
			// 		ruo:true,
			// 		teacher:"李老师",
			// 		time:'2024-08-22 11:30',
			// 		url:'https://read2.bluebirdabc.com/exam/#/home?pid=w7398uoaiIAF98wu&cid=40'+'&user_id='+JSON.parse(localStorage.getItem('userInfo')).qfUserId+'&token='+JSON.parse(localStorage.getItem('userInfo')).qfToken
			// 	},
			// 	{
			// 		id:2,
			// 		name:'湖南2024中考模拟考试--英语',
			// 		bg:require('../assets/banner-3.png'),
			// 		text:'湖南2024中考模拟考试--英语',
			// 		ruo:true,
			// 		subject:2,
			// 		teacher:"李老师",
			// 		time:'2024-08-22 12:30',
			// 		url:'https://read2.bluebirdabc.com/exam/#/home?pid=w7398uoaiIAF98wu&cid=41'+'&user_id='+JSON.parse(localStorage.getItem('userInfo')).qfUserId+'&token='+JSON.parse(localStorage.getItem('userInfo')).qfToken
			// 	}
			// ],
			startTime: null, // 开始时间
			userInfo:JSON.parse(localStorage.getItem('userInfo')),
			tabList:[
				{
					id:1,
					name:'数学'
				},
				{
					id:2,
					name:'英语'
				},
				{
					id:3,
					name:'物理'
				},
			]
		}
	},

	created(){
		// this.setTab();
		if(!this.actTab){
			localStorage.removeItem('actTab');
			this.$message('当前没有学习权限，请联系老师');
			return;
		}
		this.getExamList();
		if(this.$route.query.type == 'home'){
			this.goQftx(JSON.parse(this.$route.query.item),this.$route.query.t)
		}
	},
	mounted() {
	    this.$eventBus.$on('initPage', this.goBack);
	},
	beforeDestroy() {
	    this.$eventBus.$off('initPage', this.goBack);
			// if(this.iframeSrc){
			// 	this.getExamAdd();
			// }
	},

	computed: {

	},
	watch: {

	},
	methods: {
		// setTab(){
		// 	if(this.userInfo.authIds.indexOf(2)!=-1&&localStorage.getItem("schoolType") == "C"){//初中数学
		// 		this.tabList.push({
		// 			id:1,
		// 			name:'数学'
		// 		})
		// 		this.actTab = 1;
		// 	}
		// 	if(this.userInfo.authIds.indexOf(1)!=-1&&localStorage.getItem("schoolType") == "C"){//初中英语
		// 		this.tabList.push({
		// 			id:2,
		// 			name:'英语'
		// 		})
		// 		if(!this.actTab){
		// 			this.actTab = 2;
		// 		}
		// 	}
		// 	if(this.userInfo.authIds.indexOf(4)!=-1&&localStorage.getItem("schoolType") == "G"){//高中数学
		// 		this.tabList.push({
		// 			id:1,
		// 			name:'数学'
		// 		})
		// 		this.actTab = 1;
		// 	}
		// 	if(this.userInfo.authIds.indexOf(3)!=-1&&localStorage.getItem("schoolType") == "G"){//高中英语
		// 		this.tabList.push({
		// 			id:2,
		// 			name:'英语'
		// 		})
		// 		if(!this.actTab){
		// 			this.actTab = 2;
		// 		}
		// 	}
		// },
		isDone(url) {
			const regex = /examinee_id=(\d+)/;
			const matches = url.match(regex);
			if (matches && matches[1] && matches[1]!=0) {
				return true
			}else{
				return false
			}
		},
		setTab(){
			if(!this.userInfo.authIds){
				return '授权时间已过，请联系相关老师开通新的授权。'
			}
			if(this.actTab == 1){
				if(this.userInfo.authIds.indexOf(3)==-1&&localStorage.getItem("schoolType") == "C"){//初中数学
					return '授权时间已过，请联系相关老师开通新的授权。'
				}
				if(this.userInfo.authIds.indexOf(4)==-1&&localStorage.getItem("schoolType") == "G"){//高中数学
					return '授权时间已过，请联系相关老师开通新的授权。'
				}
			}else if(this.actTab == 2){
				if(this.userInfo.authIds.indexOf(1)==-1&&localStorage.getItem("schoolType") == "C"){//初中英语
					return '授权时间已过，请联系相关老师开通新的授权。'
				}
				if(this.userInfo.authIds.indexOf(2)==-1&&localStorage.getItem("schoolType") == "G"){//高中英语
					return '授权时间已过，请联系相关老师开通新的授权。'
				}
			}else if(this.actTab == 3){
				if(this.userInfo.authIds.indexOf(5)==-1&&localStorage.getItem("schoolType") == "C"){//初中物理
					return '授权时间已过，请联系相关老师开通新的授权。'
				}
				if(this.userInfo.authIds.indexOf(6)==-1&&localStorage.getItem("schoolType") == "G"){//高中物理
					return '授权时间已过，请联系相关老师开通新的授权。'
				}
			}
			return false
		},
		async getExamList(){
			let grades;
			if(localStorage.getItem("schoolType")){
				grades = localStorage.getItem("schoolType") === "C" ? '初中' : '高中';
			}
			let jsondata = {
				subject:this.actTab,//学科
				level:grades||this.userInfo.gradeClass.split("/")[0],//年级
				pid:"w7398uoaiIAF98wu",//pid
				user_id:JSON.parse(localStorage.getItem('userInfo')).qfUserId
			};
			const res = await this.$api.getExamList(jsondata);
			if (res.data.code === 0) {
				this.examList = res.data.data
				console.dir(this.examList)
			} else {
				this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
			}
		},
		calculateTimeSpent() {
			// 计算停留时间（分钟）
			const timeSpent = (new Date() - this.startTime) / 1000;
			console.log(`页面停留时间：${parseInt(timeSpent)} 秒`);
			return parseInt(timeSpent)
		},
		goQftx(item,t){
			let msg = this.setTab();
			if(msg){
				this.$message.warning(msg);
				return;
			}
			this.showIframe = true;
			if(t){
				this.iframeSrc = item.url.replace(/(examinee_id=)\d+/, '$10');
			}else{
				this.iframeSrc = item.url;
			}
			console.dir(this.iframeSrc)
			this.exam = item;
			// 记录进入页面的时间
			this.startTime = new Date();
		},
		getSubject(i){
			this.actTab = i
			localStorage.setItem('actTab',i);
			this.getExamList();
		},
		goBack(){
			this.showIframe = false;
			this.iframeSrc = '';
			// this.getExamAdd();
		},
		//学习知识点完结操作
		async getExamAdd(){
			let jsondata = {
				examId:this.exam.id,
				examName:this.exam.title,
				subject:this.actTab,//学科
				type:3,//考试
				operaLongTime: ""+this.calculateTimeSpent(),
			};
			const res = await this.$api.getExamAdd(jsondata);
			if (res.data.success) {
				localStorage.setItem('courseHot',true);
				localStorage.setItem('testHot',true);
			} else {
				this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
			}
		},
	}
}
</script>

<style lang="scss" scoped>
.course-list{
	padding: 1.5rem 0 5rem 0.75rem;
	.sub-head{
		margin-bottom: 1.25rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-left: 0.75rem;
		.course-title{
			font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
			font-weight: 500;
			font-size: 1.6rem;
			color: #000000;
			line-height: 1.7rem;
		}
		.course-more{
			display: flex;
			align-items: center;
			font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
			font-size: 1.2rem;
			color: rgba(0,0,0,0.8);
			line-height: 1.41rem;
			img{
				width: 1.4rem;
				height: 1.4rem;
			}
		}
		.subject{
			display: flex;
			font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
			font-size: 1.4rem;
			color: #000000;
			line-height: 1.64rem;
			margin-right: 1.5rem;
			.tab{
				width: 5.5rem;
				height: 2.5rem;
				line-height: 2.5rem;
				text-align: center;
				border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
				margin-left: 5.8rem;
			}
			.actTab{
				background: rgb(100, 45, 113);
				color: #fff;
			}
		}
	}
	.course-cont{
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-start;
		.course-card{
			width: 18.35rem;
			height: 14.45rem;
			background: #FFFFFF;
			border-radius: 0.8rem 0.8rem 0.8rem 0.8rem;
			margin: 0.7rem;
			.course-bg{
				width: 18.35rem;
				height: 7.5rem;
				background-repeat: no-repeat;
				background-size: cover;
				position: relative;
				background-image: url('../assets/exam-banner.png');
				.course-study{
					position: absolute;
					top: 0.75rem;
					left: 0.75rem;
					width: 4.35rem;
					height: 1.8rem;
					background: rgba(141,51,0,0.77);
					border-radius: 3rem 3rem 3rem 3rem;
					font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
					font-size: 0.8rem;
					color: rgb(100, 45, 113);
					line-height: 1.8rem;
					text-align: center;
				}
				.course-ruo{
						position: absolute;
						right: 0;
						top: 0;
						width: 2.45rem;
						height: 2.05rem;
				}
			}
			.course-name{
				margin: 0.75rem 0.9rem 0.6rem;
				font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
				font-weight: 500;
				font-size: 1.2rem;
				color: #1D1D1D;
				line-height: 1.4rem;
			}
			.course-text{
				margin: 0 0.9rem 0.5rem;
				font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
				font-size: 0.8rem;
				color: #74798C;
				line-height: 1rem;
			}
			.course-btn{
				display: flex;
				justify-content: flex-end;
				padding-right: 1rem;
				.btn{
					border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
					padding: 5px 10px;
					height: 2rem;
					border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
					border: 0.05rem solid #642d71;
					color: #642d71;
					display: flex;
					justify-content: center;
					align-items: center;
					padding: 0 0.75rem;
					margin-left: 1.5rem;
					.test-list-icon{
						width: 1rem;
						height: 1rem;
						background-repeat: no-repeat;
						background-size: contain;
						margin-right: 0.5rem;
					}
					.reading-icon-no{
						background-image: url(../assets/reading-icon-no.png);
					}
					.reading-icon{
						background-image: url(../assets/reading-icon.png);
					}
				}
				.btn-ok{
					background: #642d71;
					color: #fff;
				}
			}
		}
	}
}
.back{
	text-align: center;
	width: 4rem;
	height: 4rem;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 100%;
	font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
	font-weight: 500;
	font-size: 1.6rem;
	line-height: 1.88rem;
	position: absolute;
	bottom: 5rem;
	left: 2rem;
	z-index: 999;
	color: #FFFFFF;
	background: rgb(100, 45, 113);
	border: 0.2rem solid #E0E0E0;
}
</style>
